module.exports = "<p>\n  trabaja componente uno\n</p>\n"